import { configureStore } from '@reduxjs/toolkit';
import { RootAction, RootState, Services } from 'MyTypes';
import { createEpicMiddleware } from 'redux-observable';

import services from '../services';
import rootEpic from './root-epic';
import rootReducer from './root-reducer';

const epicMiddleware = createEpicMiddleware<RootAction, RootAction, RootState, Services>({
    dependencies: services,
});

export function createStore(initialState?: Partial<RootState>) {
    const store = configureStore({
        reducer: rootReducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: true,
                serializableCheck: false,
                immutableCheck: false,
            }).concat(epicMiddleware),
        devTools: config.env !== 'production',
    });

    epicMiddleware.run(rootEpic);

    return store;
}
